import { FilterListLinkBean } from 'common/api/api.ts';
import { FC } from 'react';
import { DictionarySelector, DictionarySelectorProps, enumToLabelValue } from './DictionarySelector'
import FilterListModeEnum = FilterListLinkBean.FilterListModeEnum

export const FilterListModeSelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="filterListMode"
                        loader={() => enumToLabelValue(FilterListModeEnum)}
    />
